import {
  Box,
  Button,
  FormControl,
  Grid,
  Avatar,
  InputLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState, useEffect } from "react";
import { getAllStudent } from "../../api/crud";
import ModalView from "../../Components/ModalView";
import { optionsBranch } from "../../data/branch-data";
import { matchOptions } from "../../utils/function";
import { generateStatus } from "../../utils/generateDisplay";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Select from "react-select";
import xlsxParser from "xls-parser";
import { BsPencilSquare } from "react-icons/bs";

const StudentManagement = () => {
  const { REACT_APP_BASE_NAME } = process.env;
  const [lists, setLists] = useState([]);
  const [filterLists, setFilterList] = useState([]);
  const [gpaList, setGpaList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalGpaPreviewOpen, setModalGpaPreviewOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);
  const [modalEditGpaOpen, setModalEditGpaOpen] = useState(false);
  const { register, control, watch, setValue } = useForm({
    // defaultValues: {
    //   students: [
    //     {
    //       name: "",
    //       id: "",
    //       b_id: "",
    //       gpa: "",
    //     },
    //   ],
    // },
  });
  //   const { fields, append, remove } = useFieldArray({
  //     name: "students",
  //     control,
  //   });

  const watchFile = watch("file");

  const onInsertXls = () => {
    setModalGpaPreviewOpen(true);
    const file = watchFile[0];

    if (file) {
      xlsxParser.onFileSelection(file).then(async (data) => {
        setGpaList(data.Sheet1);
      });
    }
  };

  const onSearchChange = (ev) => {
    setSearchTerm(ev.target.value);

    const results = lists.filter((item) => {
      return (
        item.id.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.branch_name?.toLowerCase().includes(ev.target.value.toLowerCase())
      );
    });

    setFilterList(results);
  };

  const onEditGpa = (item) => {
    setModalEditGpaOpen(true);
    setItemSelected(item);

    setValue("edit.id", item.id);
    setValue("edit.name", item.name);
    setValue(
      "edit.branch",
      optionsBranch.find((op) => op.value == item.b_id)
    );
    setValue("edit.gpa", item.gpa);
    setValue("edit.status", item.status);
  };

  const getData = () => {
    getAllStudent()
      .then((res) => {
        const newRes = res.map((item) => {
          return {
            ...item,
            branch_name: matchOptions(optionsBranch, item.b_id),
          };
        });

        setLists(newRes);
        setFilterList(newRes);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateStatusFn = (item) => {
    if (item == 0) {
      return <span className="badge bg-danger">Inactive</span>;
    } else if (item == 1) {
      return <span className="badge bg-primary">Active</span>;
    } else if (item == 2) {
      return <span className="badge bg-success">Completed</span>;
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const displayInsertXls = (
    <div className="d-flex align-items-center py-3">
      <a
        href={`${REACT_APP_BASE_NAME}/assets/file/sample-gpa.xlsx`}
        className="btn ms-2  text-nowrap"
        target="_blank"
      >
        ตัวอย่างไฟล์
      </a>
      <input
        type="file"
        className="form-control mx-2"
        {...register("file")}
        style={{ width: "250px" }}
      />
      <Button variant="contained" onClick={onInsertXls} disabled={!watchFile}>
        นำเข้า
      </Button>
    </div>
  );

  const displayTable = (
    <>
      <div className="card-header">
        <div
          className="d-flex justify-content-between  flex-wrap"
          style={{ minHeight: "50px" }}
        >
          <h5 className="card-title ">
            รายชื่อนิสิต{" "}
            <Button variant="contained" onClick={() => setModalAddOpen(true)}>
              เพิ่ม
            </Button>
          </h5>
          <div>
            <input
              type="text"
              style={{ maxWidth: 300 }}
              className="form-control"
              placeholder="ค้นหา"
              onChange={onSearchChange}
              value={searchTerm}
            />

            <div>{!!searchTerm && `พบ ${filterLists.length} ผลลัพธ์`}</div>
          </div>
        </div>
      </div>
      <div className="overflow-auto">
        <table
          id="datatables-dashboard-projects"
          className="table table-striped my-0 table-hover"
        >
          <thead>
            <tr className="text-nowrap">
              <th>รหัสนักศึกษา</th>
              <th>ชื่อ - สกุล</th>
              <th>สาขา</th>
              <th>เกรดเฉลี่ย</th>
              <th>Status</th>
              <th>แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {!!filterLists.length &&
              filterLists.map((el) => {
                return (
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.name}</td>
                    <td>{el.branch_name}</td>
                    <td>{el.gpa}</td>
                    <td>{generateStatusFn(el.status)}</td>
                    <td>
                      <Button onClick={() => onEditGpa(el)}>
                        <BsPencilSquare />
                      </Button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  const displayModalAdd = (
    <ModalView
      isModaOpen={modalAddOpen}
      setIsModalOpen={setModalAddOpen}
      title="เพิ่มนิสิต"
    >
      <Box width={500} paddingY={3}>
        <form action="./add-students.php" method="post">
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                {...register(`id`)}
                placeholder="รหัสนิสิต"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                {...register(`name`)}
                placeholder="ชื่อ"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name={`branch`}
                control={control}
                render={({ field }) => {
                  return <Select options={optionsBranch} {...field} />;
                }}
              />
              <input
                className="d-none"
                value={watch("branch")?.value}
                name="b_id"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                {...register(`gpa`)}
                placeholder="เกรดเฉลี่ย"
              />
            </Grid>
          </Grid>
          <Button type="submit">บันทึก</Button>
        </form>
      </Box>
    </ModalView>
  );

  const optionsStatus = [
    { label: "Inactive", value: "0" },
    { label: "Active", value: "1" },
    { label: "Completed", value: "2" },
  ];

  const displayModalEdit = (
    <ModalView
      isModaOpen={modalEditGpaOpen}
      setIsModalOpen={setModalEditGpaOpen}
      title="แก้ไขข้อมูลนิสิต"
    >
      <div className="card-header">
        <Avatar
          alt="profile"
          sx={{ width: 100, height: 100 }}
          src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${itemSelected?.id}`}
        />
      </div>

      <Box minHeight={300}>
        <form action="./update-student.php" method="post">
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                {...register(`edit.id`)}
                readOnly
                placeholder="รหัสนิสิต"
                value={watch("edit.id")?.value}
                name="st_id"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                {...register(`edit.name`)}
                placeholder="ชื่อ"
                readOnly
                value={watch("edit.name")?.value}
                name="st_name"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                value={watch("edit.branch")?.label}
                readOnly
              />

              <input
                className="d-none"
                value={watch("edit.branch")?.value}
                name="b_id"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                {...register(`edit.gpa`)}
                placeholder="เกรดเฉลี่ย"
                value={watch("edit.gpa")?.value}
                name="st_gpa"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="edit.status"
                control={control}
                render={({ field }) => {
                  return (
                    <Select
                      options={optionsStatus}
                      {...field}
                      defaultValue={optionsStatus[itemSelected?.status]}
                    />
                  );
                }}
              />
            </Grid>
          </Grid>
          <input
            className="d-none"
            name="status"
            value={watch("edit.status")?.value}
            readOnly
          />
          <Button type="submit">บันทึก</Button>
        </form>
        <div>
          ตรวจสอบข้อมูลจากระบบทะเบียน
          <a
            target="_blank"
            className="ms-2"
            href={`http://reg.buu.ac.th/registrar/studentByProgram_1.asp?vcmd=14&studentcode=${itemSelected?.id}`}
          >
            reg.buu.ac.th
          </a>
        </div>
      </Box>
    </ModalView>
  );

  const displayModalGpaPreview = (
    <ModalView
      isModaOpen={modalGpaPreviewOpen}
      setIsModalOpen={setModalGpaPreviewOpen}
      title="นำเข้า GPA"
    >
      <form action="./update-gpa-students.php" method="post">
        <table className="table" style={{ width: "500px" }}>
          <thead>
            <tr>
              <th>รหัสนักศึกษา</th>
              <th>GPA</th>
            </tr>
          </thead>
          <tbody>
            {!!gpaList.length &&
              gpaList.map((el) => {
                return (
                  <tr>
                    <td>
                      {el.id}
                      <input name="id[]" className="d-none" value={el.id} />
                    </td>
                    <td>
                      {el.gpa}
                      <input name="gpa[]" className="d-none" value={el.gpa} />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>{" "}
        <Button type="submit">บันทึกข้อมูล</Button>
      </form>
    </ModalView>
  );

  return (
    <div>
      <div className="main">
        <main className="content">
          <div className="container-fluid p-0">
            <div className="card flex-fill">
              {displayInsertXls}
              {displayTable}
            </div>
          </div>
        </main>
      </div>
      {displayModalAdd}
      {displayModalEdit}
      {displayModalGpaPreview}
    </div>
  );
};

export default StudentManagement;
